import React, { useEffect, useState } from "react";
import { navigate, withPrefix } from "gatsby";
import styled from "styled-components";
import DiscussionInterior from "./DiscussionInterior";
import DiscussionLanding from "./DiscussionLanding";
import { DiscussionProvider, useDiscussion } from "./DiscussionContext";

const Discussion = ({itemToLoad, viewIsLanding = true}) => {

  return (
    <DiscussionProvider itemToLoad={itemToLoad}>
      <DiscussionContent viewIsLanding={viewIsLanding} />
    </DiscussionProvider>
  );
};

export default Discussion;

const DiscussionContent = ({viewIsLanding}) => {
  const { entities, entity, getEntityHash, getEntityTitle, entityHasFlag } = useDiscussion();

  const [isLanding, setIsLanding] = useState(entity ? false : viewIsLanding);

  function handleLoadFromOldHash() {
    const hash = window?.location?.hash?.replace("#", "");
    if ( hash === "stakeholders") {
      navigate("/discussion/stakeholders");
    }
    else if ( hash ) {
      const entity = entities.find(item => item.slug === hash || item?.old_slugs?.includes(hash));
      if ( entity ) {
        navigate(getEntityHash(entity, false));
      }
    }
  }

  useEffect(() => {
    handleLoadFromOldHash();
  }, []);

  return (

    <StyledDiscussion className={entity ? "is-entity-view" : undefined}>
      {isLanding ? (
        <DiscussionLanding 
          entities={entities}
          getEntityHash={getEntityHash}
          getEntityTitle={getEntityTitle}
          entityHasFlag={entityHasFlag}
        />
      ) : (
        <DiscussionInterior 
          entities={entities}
          entity={entity}
          getEntityHash={getEntityHash}
          getEntityTitle={getEntityTitle}
          entityHasFlag={entityHasFlag}
        />
      )}
    </StyledDiscussion>
  )
}

const StyledDiscussion = styled.div`
`;

